import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["otherFields", "descriptionField"]

  connect() {
    console.log("Subject form controller connected")
    
    // Get elements by ID
    const teachingCycleSelect = document.getElementById("subject_teaching_cycle_id")
    const subjectKeySelect = document.getElementById("subject_subject_key_id")
    const subjectCategorySelect = document.getElementById("subject_subject_category_id")
    
    console.log("Teaching cycle select:", teachingCycleSelect)
    console.log("Subject key select:", subjectKeySelect)
    console.log("Subject category select:", subjectCategorySelect)
    
    // Show other fields if teaching cycle is already selected
    if (teachingCycleSelect && teachingCycleSelect.value) {
      console.log("Teaching cycle already selected:", teachingCycleSelect.value)
      this.showOtherFields()
    }
  }

  onTeachingCycleChange(event) {
    console.log("Teaching cycle changed:", event.target.value)
    const teachingCycleId = event.target.value
    
    if (teachingCycleId) {
      console.log("Loading data for teaching cycle:", teachingCycleId)
      this.showOtherFields()
      this.loadSubjectKeysForCycle(teachingCycleId)
      this.loadSubjectCategoriesForCycle(teachingCycleId)
    } else {
      console.log("No teaching cycle selected, hiding fields")
      this.hideOtherFields()
      this.clearSubjectKey()
      this.clearSubjectCategory()
    }
  }

  showOtherFields() {
    console.log("Showing other fields")
    if (this.hasOtherFieldsTarget) {
      this.otherFieldsTarget.style.display = "grid"
    }
    if (this.hasDescriptionFieldTarget) {
      this.descriptionFieldTarget.style.display = "block"
    }
  }

  hideOtherFields() {
    console.log("Hiding other fields")
    if (this.hasOtherFieldsTarget) {
      this.otherFieldsTarget.style.display = "none"
    }
    if (this.hasDescriptionFieldTarget) {
      this.descriptionFieldTarget.style.display = "none"
    }
  }

  // Simple method to update regular select options
  updateSelectOptions(selectElement, options) {
    if (!selectElement) return
    
    console.log("Updating select options for:", selectElement.id)
    console.log("New options:", options)
    
    // Clear existing options
    selectElement.innerHTML = ''
    
    // Add new options
    options.forEach(option => {
      const optionElement = document.createElement('option')
      optionElement.value = option.value
      optionElement.textContent = option.text
      if (option.selected) {
        optionElement.selected = true
      }
      selectElement.appendChild(optionElement)
    })
    
    console.log("Updated select options, total options:", selectElement.options.length)
  }

  loadSubjectKeysForCycle(teachingCycleId) {
    console.log("Loading subject keys for cycle:", teachingCycleId)
    
    fetch(`/schools/books/subjects/subject_keys_for_cycle?teaching_cycle_id=${teachingCycleId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      credentials: 'same-origin'
    })
    .then(response => {
      console.log("Subject keys response status:", response.status)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(subjectKeys => {
      console.log("Subject keys received:", subjectKeys)
      this.updateSubjectKeyOptions(subjectKeys)
    })
    .catch(error => {
      console.error('Error loading subject keys:', error)
      this.clearSubjectKey()
    })
  }

  loadSubjectCategoriesForCycle(teachingCycleId) {
    console.log("Loading subject categories for cycle:", teachingCycleId)
    
    fetch(`/schools/books/subjects/subject_categories_for_cycle?teaching_cycle_id=${teachingCycleId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      credentials: 'same-origin'
    })
    .then(response => {
      console.log("Subject categories response status:", response.status)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(subjectCategories => {
      console.log("Subject categories received:", subjectCategories)
      this.updateSubjectCategoryOptions(subjectCategories)
    })
    .catch(error => {
      console.error('Error loading subject categories:', error)
      this.clearSubjectCategory()
    })
  }

  updateSubjectKeyOptions(subjectKeys) {
    console.log("Updating subject key options with:", subjectKeys)
    
    const select = document.getElementById("subject_subject_key_id")
    if (!select) {
      console.error("Subject key select element not found!")
      return
    }
    
    const existingSubjectKeyId = select.dataset.existingSubjectKeyId
    
    // Prepare options
    const options = [
      { value: '', text: 'Select a subject', selected: false }
    ]
    
    subjectKeys.forEach(subjectKey => {
      options.push({
        value: subjectKey.id.toString(),
        text: subjectKey.name,
        selected: existingSubjectKeyId && subjectKey.id.toString() === existingSubjectKeyId
      })
    })
    
    this.updateSelectOptions(select, options)
  }

  updateSubjectCategoryOptions(subjectCategories) {
    console.log("Updating subject category options with:", subjectCategories)
    
    const select = document.getElementById("subject_subject_category_id")
    if (!select) {
      console.error("Subject category select element not found!")
      return
    }
    
    const existingSubjectCategoryId = select.dataset.existingSubjectCategoryId
    
    // Prepare options
    const options = [
      { value: '', text: 'Select a category (optional)', selected: false }
    ]
    
    subjectCategories.forEach(subjectCategory => {
      options.push({
        value: subjectCategory.id.toString(),
        text: subjectCategory.name,
        selected: existingSubjectCategoryId && subjectCategory.id.toString() === existingSubjectCategoryId
      })
    })
    
    this.updateSelectOptions(select, options)
  }

  clearSubjectKey() {
    console.log("Clearing subject key options")
    
    const select = document.getElementById("subject_subject_key_id")
    if (!select) {
      console.error("Subject key select element not found!")
      return
    }
    
    const options = [
      { value: '', text: 'Select a teaching cycle first', selected: true }
    ]
    
    this.updateSelectOptions(select, options)
  }

  clearSubjectCategory() {
    console.log("Clearing subject category options")
    
    const select = document.getElementById("subject_subject_category_id")
    if (!select) {
      console.error("Subject category select element not found!")
      return
    }
    
    const options = [
      { value: '', text: 'Select a teaching cycle first', selected: true }
    ]
    
    this.updateSelectOptions(select, options)
  }
}
